module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBold.55d9b393.ttf";